import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Drawer, List, ListItem, ListItemText, Modal, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AssignStff from "./AssignStff";
import {deleteService, deleteStaff, getRiyoDaySearch, getStaffKinmuList} from "../../api/client";

export default function EditSchedules(props) {
  const loadParams = (nm) => {
    return sessionStorage.getItem(nm) || "";
  };
  // const saveParams = (nm, val) => {
  //   return sessionStorage.setItem(nm, val);
  // };
  const loadJson = (nm) => {
    return JSON.parse(sessionStorage.getItem(nm)) || [];
  };
  const saveJson = (nm, val) => {
    return sessionStorage.setItem(nm, JSON.stringify(val));
  };
  const [state, setState] = React.useState({
    expanded: "",
    assignExpanded: false,
    deleteExpanded: false
  });
  const [edit, setEdit] = React.useState({
    s2st004200Slug: "",
    s2st004211Slug: "",
    stffNo: "",
    noValue: "",
    item: {},
    stffList: []
  });
  const setExpanded = (item) => {
    if (item.status !== "2") {
      const expanded = loadParams("editScheduleDate") + "-" + item.s2st004200Slug + "-" + item.s2st004211Slug
      setState({...state, expanded: state.expanded === expanded ? "" : expanded});
    };
  };
  async function setAssignExpanded(item) {
    const stffList = await getStaffKinmuList({s2st004200Slug: item.s2st004200Slug}).catch(error => props.errorFunc(error));
    if (Boolean(stffList)) {
      setState({...state, assignExpanded: true});
      setEdit({...edit, s2st004200Slug: item.s2st004200Slug, s2st004211Slug: item.s2st004211Slug, noValue: item.noValue, item: item, stffList: stffList.data});
    };
  };
  const setDeleteExpanded = (item) => {
    setState({...state, deleteExpanded: true});
    setEdit({...edit, s2st004200Slug: item.s2st004200Slug, s2st004211Slug: item.s2st004211Slug, noValue: item.noValue, stffNo: item.stffNo});
  };
  async function deleteData(i, status) {
    const result = await (Boolean(edit.stffNo) ? deleteStaff(edit) : deleteService(edit)).catch(error => props.errorFunc(error));
    const data = await getRiyoDaySearch({ymdDt: loadParams("editScheduleDate"), bsJg: loadParams("jgCd"), riyoNo: loadParams("riyoNo")}).catch(error => props.errorFunc(error));
    setState({...state, expanded: Boolean(edit.stffNo) ? state.expanded : "", deleteExpanded: false});
    setEdit({...edit, s2st004200Slug: "", s2st004211Slug: "", noValue: "", stffNo: ""});
    saveJson("data", data.data);
    props.setToastState({...props.toastState, error: false, message: result.data.message});
  };

  return (
    <>
    <List
      sx = {{m: "auto", textAlign: "center"}}
    >
      {loadJson("data").map((item, i) => (
        <Box
          key = {"tl_" + i}
        >
          <Divider
            component = "li"
            sx = {{mt: 1, mb: 1}}
            variant = "inbox"
          />
          <Accordion
            className = "bgcolor-gray-quarter"
            expanded = {state.expanded === loadParams("editScheduleDate") + "-" + item.s2st004200Slug + "-" + item.s2st004211Slug}
            onClick = {() => setExpanded(item)}
            sx = {{m: 0, p: 2, textAlign: "left", boxShadow: "none", borderRadius: "0!important"}}
          >
            <AccordionSummary
              expandIcon = {<ExpandMoreIcon fontSize = "small" sx = {item.status === "2" ? {color: "rgba(0, 0, 0, 0.54)", visibility: "hidden"} : {color: "rgba(0, 0, 0, 0.54)"}} />}
              sx = {{p: 0, height: 100, minHeight: "0!important"}}
            >
              <ListItem
                alignItems = "flex-start"
                sx = {{mt: 1, mb: 1, pt: 0, pb: 0}}
              >
                <ListItemText
                  primary = {
                    <React.Fragment>
                      {item.adminCheckFg === "1" &&
                      <Box
                        className = "btn-select"
                        sx = {{width: "fit-content", mb: 0.5}}
                      >
                        <Typography>
                          管理者確認済
                        </Typography>
                      </Box>}
                      {item.status === "2" &&
                      <Box
                        className = "btn-select"
                        sx = {{width: "fit-content", mb: 0.5}}
                      >
                        <Typography>
                          実施済
                        </Typography>
                      </Box>}
                      {parseInt(item.status) > 2 &&
                      <Box
                        className = "btn-caution"
                        sx = {{width: "fit-content", mb: 0.5}}
                      >
                        <Typography>
                          キャンセル
                        </Typography>
                      </Box>}
                      {!Boolean(item.timelessOtherFg) &&
                      <Typography>
                        {item.status === "2" ? "実績" : "予定"}：{item.hourfDt}～{item.hourtDt}
                      </Typography>}
                    </React.Fragment>
                  }
                  secondary = {
                    <React.Fragment>
                      <Typography
                        sx = {{display: "inline"}}
                      >
                        職員：{item.stffNm || "未割当"}
                      </Typography>
                      <br></br>
                      <Typography
                        sx = {{display: "inline"}}
                      >
                        {item.serviceNm || "--"}
                      </Typography>
                    </React.Fragment>
                  }
                  secondaryTypographyProps = {{component: "div", sx: {mt: 1}}}
                />
              </ListItem>
            </AccordionSummary>
            <AccordionDetails
              sx = {{p: 0}}
            >
              <ListItemText
                secondary = {
                  <React.Fragment>
                    <Box
                      sx = {{display: "flex", mb: 1}}
                    >
                      <Button
                        className = "btn-submit"
                        onClick = {(e) => {
                          setAssignExpanded(item);
                          e.stopPropagation();
                        }}
                        sx = {{display: "block", mr: "auto", pt: 0.5, pb: 0.5, width: 120}}
                      >
                        <Typography
                          className = "btn-txt-sm"
                        >
                          割当変更
                        </Typography>
                      </Button>
                      <Button
                        className = "btn-caution"
                        onClick = {(e) => {
                          setDeleteExpanded(item);
                          e.stopPropagation();
                        }}
                        sx = {{display: "block", ml: "auto", pt: 0.5, pb: 0.5, width: 120}}
                      >
                        <Typography
                          className = "btn-txt-sm"
                        >
                          {Boolean(item.stffNo) ? "割当" : "予定"}削除
                        </Typography>
                      </Button>
                    </Box>
                  </React.Fragment>
                }
                secondaryTypographyProps = {{component: "div"}}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      ))}
      <Divider
        variant = "inbox"
        component = "li"
      />
      {!Boolean(loadJson("data").length) &&
      <Typography
        sx = {{pt: 1}}
      >
        訪問予定なし
      </Typography>}
    </List>
    <Drawer
        anchor = "bottom"
        open = {state.assignExpanded}
        PaperProps = {{sx: {maxHeight: "60%"}}}
    >
      <AssignStff
        edit = {edit}
        errorFunc = {props.errorFunc}
        setEdit = {setEdit}
        setState = {setState}
        setToastState = {props.setToastState}
        state = {state}
        toastState = {props.toastState}
      />
    </Drawer>
    <Modal
      open = {state.deleteExpanded}
      closeAfterTransition
    >
      <Box
        className = "basic-modal"
      >
        <Typography>
          {Boolean(edit.stffNo) ? "割当" : "予定"}を削除しますか？
        </Typography>
        <Typography>
          ※この操作は取り消せません。
        </Typography>
        <Box
          sx = {{textAlign: "right"}}
        >
          <Button
            onClick = {() => deleteData()}
            sx = {{}}
            >
            はい
          </Button>
          <Button
            onClick = {() => {
              setState({...state, deleteExpanded: false});
              setEdit({...edit, s2st004200Slug: "", s2st004211Slug: "", noValue: "", stffNo: ""});
            }}
            sx = {{}}
          >
            いいえ
          </Button>
        </Box>
      </Box>
    </Modal>
    </>
  );
};
